// extracted by mini-css-extract-plugin
export var displayNone = "_kk-6";
export var imgContainer = "_kk-2";
export var overflowHidden = "_kk-3";
export var productInfoCardButtonContainer = "_kk-5";
export var productTitleText = "_kk-4";
export var rightArrow = "_kk-1";
export var rightArrowContainer = "_kk-0";